// src/components/EditDialog.js
import React, { useState, useEffect } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { useServiceContext } from '../../components/Context/ServiceContext';

const EditDialogServiceCategory = ({
    open,
    handleClose,
    type, // 'brand' or 'model'
    currentData,
    brands,
    handleSave,
}) => {
    const [catName, setCatName] = useState(null);
    const [Id, setId] = useState(null);
    const { editType } = useServiceContext();
    const [categoryPhotoUrl, setCategoryPhotoUrl] = useState(''); // existing photo URL
    const [photo, setPhoto] = useState(null); // new uploaded file
    const [preview, setPreview] = useState(null); // preview for new file
    const [showInCustomerApp, setShowInCustomerApp] = useState(true);
    const [isActive, setIsActive] = useState(true);

 
    useEffect(() => {
         
       
        if (currentData) {
            setCatName(currentData.serviceCategoryName);
            setCategoryPhotoUrl(currentData.icon)
            setId(currentData.id || '');
            setShowInCustomerApp(currentData.showInCustomerApp !== false);
            setIsActive(currentData.isActive !== false);
            setPhoto(null);
            setPreview(null);
        }
    }, [currentData]);

    const onSave = () => {
        if (type === 'category') {
            if (!catName) {
                alert('Category name cannot be empty.');
                return;
            }

            handleSave(catName, currentData.serviceCategoryId, photo, showInCustomerApp, isActive);
        }
        handleClose();
    };





    return (
        <div>
            {editType === "category" && (
                <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                    <DialogTitle>Edit Service Category</DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Category Name"
                            value={catName}
                            onChange={(e) => setCatName(e.target.value)}
                            fullWidth
                            margin="dense"
                        />

                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isActive}
                                    onChange={(e) => setIsActive(e.target.checked)}
                                    color="primary"
                                />
                            }
                            label="Active (branch / order screens)"
                            sx={{ mt: 2, display: 'block' }}
                        />

                        <FormControlLabel
                            control={
                                <Switch
                                    checked={showInCustomerApp}
                                    onChange={(e) => setShowInCustomerApp(e.target.checked)}
                                    color="primary"
                                />
                            }
                            label="Show in Customer App"
                            sx={{ mt: 1, display: 'block' }}
                        />

                        {/* Category Photo Section */}
                        <div className="mt-3">
                            <label className="form-label">Category Photo</label>
                            <div className="d-flex flex-column align-items-start gap-2">
                                {/* Preview Image */}
                                {preview || categoryPhotoUrl ? (
                                    <img
                                        src={preview || categoryPhotoUrl}
                                        alt="Category"
                                        style={{
                                            width: "120px",
                                            height: "120px",
                                            borderRadius: "8px",
                                            objectFit: "cover",
                                            border: "1px solid #ddd",
                                        }}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            width: "120px",
                                            height: "120px",
                                            borderRadius: "8px",
                                            border: "1px dashed #ccc",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#aaa",
                                            fontSize: "0.9rem",
                                        }}
                                    >
                                        No Photo
                                    </div>
                                )}

                                {/* Upload New Photo */}
                                <Button
                                    variant="outlined"
                                    component="label"
                                    size="small"
                                    color="primary"
                                >
                                    Change Photo
                                    <input
                                        hidden
                                        accept="image/*"
                                        type="file"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                setPhoto(file);
                                                setPreview(URL.createObjectURL(file));
                                            }
                                        }}
                                    />
                                </Button>
                            </div>
                        </div>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button
                            onClick={onSave}
                            color="primary"
                            variant="contained"
                            disabled={!catName}
                        >
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </div>

  );
};

export default EditDialogServiceCategory;
